export default function Setting(){
    return <>
        Setting Page
    </>
}